import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

// Define a type for the slice state
interface ChildProfileDataSlice {
  firstname: string;
  lastname: string;
  gender: string;
  school: string;
  dobDay: string;
  dobMonth: string;
  dobYear: string;
  avatar: string;
}

// Define the initial state using that type
const initialState: ChildProfileDataSlice = {
  firstname: '',
  lastname: '',
  gender: '',
  school: '',
  dobDay: '',
  dobMonth: '',
  dobYear: '',
  avatar: 'avatar-cody',
};

export const childProfileDataSliceSlice = createSlice({
  name: 'childProfileData',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setChildProfileData(
      state,
      action: PayloadAction<{
        dataKey: keyof ChildProfileDataSlice;
        data: string;
      }>,
    ): void {
      state[action.payload.dataKey] = action.payload.data;
    },
  },
});

export const { setChildProfileData } = childProfileDataSliceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectChildProfileData = (
  state: RootState,
): ChildProfileDataSlice => {
  return state.childProfileData;
};

export default childProfileDataSliceSlice.reducer;
